export const ADD_DEPENDENT = 'ADD_DEPENDENT';
export const REQUEST_DEPENDENT_IDENTIFICATION = 'REQUEST_DEPENDENT_IDENTIFICATION';
export const SUCCESS_DEPENDENT_IDENTIFICATION = 'SUCCESS_DEPENDENT_IDENTIFICATION';
export const FAILED_DEPENDENT_IDENTIFICATION = 'FAILED_DEPENDENT_IDENTIFICATION';

export const addDependent = (dependentsSize) => ({
  type: ADD_DEPENDENT,
  payload: dependentsSize,
});

export const requestDependentIdentification = (identification, index, productId) => ({
  type: REQUEST_DEPENDENT_IDENTIFICATION,
  payload: { identification, index, productId },
});

export const successDependentIdentification = (citizen, index, productId) => ({
  type: SUCCESS_DEPENDENT_IDENTIFICATION,
  payload: { citizen, index, productId },
});

export const failedDependentIdentification = (error, index, productId) => ({
  type: FAILED_DEPENDENT_IDENTIFICATION,
  payload: { error, index , productId },
});
